export default {
    en: {
        custom: {
            customRevenueShare: {
              required_if: () => 'Revenue share is required, it can be 0'
            }
        },
        attributes: {
            accountType: 'account type',
            address_1: 'address',
            agreeToTerms: 'terms and conditions',
            customRevenueShare: 'revenue share',
            earlyBirdStartDay: 'early bird start day',
            earlyBirdEndDay: 'early bird end day',
            earlyBirdDiscount: 'early bird discount',
            earlyBirdEndTime: 'early bird end time',
            earlyBirdStartTime: 'early bird start time',
            endTime: 'end time',
            first_name: 'first name',
            gaEndDay: 'general admissions end day',
            gaStartDay: 'general admissions start day',
            gaEndTime: 'general admissions end time',
            gaStartTime: 'general admissions start time',
            hostEmail: 'host email',
            hostName: 'host name',
            hostPhone: 'host phone',
            last_name: 'last name',
            loadEarlyBirdEndTime: 'general admission end time',
            loadEarlyBirdStartTime: 'early bird start time',
            loadEndTime: 'end time',
            loadGaEndTime: 'general admission end time',
            loadGaStartTime: 'general admission start time',
            loadStartTime: 'start time',
            organization_name: 'organization name',
            organization_url: 'organization URL',
            password_confirmation: 'password',
            revenueShare: 'revenue share',
            signDate: 'sign date',
            startDate: 'start date',
            startTime: 'start time',
            thankYouUrl: 'thank you URL',
            thirdPartyUrl: 'third party URL',
            venueAddress1: 'venue address',
            venueName: 'venue name',
            venueUrl: 'venue URL',
            hasHostedBefore: 'has hosted before',
            referredBy: 'referred by',
            openToPartnership: 'open to partnership',
            // needMiniGrant: 'need mini-grant',
            paymentMethod: 'payment method',
            paymentDetails: 'payment details',
        }
    }
};
